import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import Plataforma from "@/pages/admin/Plataforma";
import { pageHead } from "@/lib/seo";

const busca = z.object({
  filtro: z.enum(["com", "sem", "todos"]).optional().catch(undefined),
  dar: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute("/admin/plataforma")({
  validateSearch: busca,
  head: () => pageHead({ title: "Plataforma | Painel", path: "/admin/plataforma", noindex: true }),
  component: Plataforma,
});
